module.exports = __webpack_public_path__ + "static/media/atlassian.b41838ca.svg";